import React, { Component, useState } from "react";
import "./QboPullCustomersModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import { Moment } from "moment-timezone";

type Props = {
    closeModalFn: () => void;
    startPullFn: (lastPullTime?: string) => void;
};

export const QboPullCustomersModal: React.FC<Props> = (props) => {
    const [dateStr, setDateStr] = useState<string>();

    const closeModal = () => {
        props.closeModalFn();
    };

    const start = () => {
        props.startPullFn(dateStr);
    };

    const handleLastUpdatedAt = (date: Moment) => {
        setDateStr(date.format("YYYY-MM-DD"));
    };

    return (
        <div className={"QboPullCustomersModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <div>
                        <OwTitle leftIconName={"fad fa-cloud-download-alt"} title={"quickbooks_online"} tag={"h3"} />
                        <OwTitle title={"pull_customers"} tag={"h5"} />
                    </div>
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-2"}>
                <div>
                    <OwLabel title={"from_last_updated_at"} />
                    <OwDateInput fn={handleLastUpdatedAt} />
                </div>
            </div>

            <div className="mt-2">
                <OwButton title={"start"} fn={start} />
            </div>
        </div>
    );
};
